module.exports = __webpack_public_path__ + "static/media/attention.43da3b57.svg";